import React, { useState } from 'react';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useAuth } from '../../contexts/AuthContext';
import { LOCATION_CONSENT_VERSION, locationConsentVersion } from '../../utils/locationConsent';

// Vises når sjåføren ikke har godtatt gjeldende samtykketekst (GDPR — lokasjonsdeling).
// Lagres til users.locationConsentAt + locationConsentVersion ved aksept.
export default function LocationConsentModal({ onConsent }) {
  const { currentUser, userDoc, refreshUserDoc } = useAuth();
  const [loading, setLoading] = useState(false);
  const isUpdate = locationConsentVersion(userDoc) > 0;

  async function handleAccept() {
    setLoading(true);
    await updateDoc(doc(db, 'users', currentUser.uid), {
      locationConsentAt:      serverTimestamp(),
      locationConsentVersion: LOCATION_CONSENT_VERSION,
    });
    // Oppdragsskjermen leser samtykket fra userDoc før den deler posisjon med bestiller
    await refreshUserDoc();
    onConsent();
  }

  function handleDecline() {
    // Kan ikke bruke sjåfør-funksjonalitet uten lokasjon
    onConsent(); // La dem gjennom, kart bruker fallback til Oslo sentrum
  }

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.iconWrap} aria-hidden="true">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#1a1a2e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 21s7-6.2 7-11.5a7 7 0 10-14 0C5 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" />
          </svg>
        </div>
        <h2 style={styles.title}>{isUpdate ? 'Oppdatert: deling av posisjon' : 'Deling av posisjon'}</h2>
        <p style={styles.body}>
          Tippi bruker din GPS-posisjon til å vise oppdrag i nærheten og sortere dem etter avstand fra deg.
        </p>
        <p style={styles.body}>
          <strong>Når du har et oppdrag, ser bestilleren hvor du er</strong> — fra du blir tildelt oppdraget
          til du har levert. Posisjonen slettes fra oppdraget når det er levert eller kansellert.
        </p>
        <p style={styles.body}>
          Posisjonen deles bare mens appen er åpen, og ikke med andre enn bestilleren av oppdraget ditt. Se vår{' '}
          <a href="/personvern" style={{ color: '#fdc149' }}>personvernerklæring</a> for detaljer.
        </p>
        <div style={styles.legal}>
          Behandlingsgrunnlag: <strong>samtykke</strong> (GDPR art. 6.1.a).
          Du kan trekke samtykket tilbake når som helst under Innstillinger.
        </div>
        <div style={styles.buttons}>
          <button className="tippi-btn" style={styles.acceptBtn} onClick={handleAccept} disabled={loading}>
            {loading ? 'Lagrer…' : 'Godta og fortsett'}
          </button>
          <button style={styles.declineBtn} onClick={handleDecline}>
            Ikke nå
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay:    { position: 'fixed', inset: 0, background: 'rgba(10,10,20,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 },
  modal:      { background: '#1a1a2e', borderRadius: 26, padding: '32px 24px 24px', maxWidth: 420, width: '100%', maxHeight: '100%', overflowY: 'auto', boxShadow: '0 8px 40px rgba(0,0,0,0.4)' },
  iconWrap:   { width: 72, height: 72, borderRadius: '50%', background: '#fdc149', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 0 20px' },
  title:      { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 38, lineHeight: 1, fontWeight: 700, color: '#fff', margin: '0 0 14px' },
  body:       { fontSize: 14, color: '#c9c9d6', lineHeight: 1.6, margin: '0 0 12px' },
  legal:      { fontSize: 12, color: '#a3a3b5', background: 'rgba(255,255,255,0.07)', borderRadius: 10, padding: '10px 12px', margin: '8px 0 20px' },
  buttons:    { display: 'flex', flexDirection: 'column', gap: 6 },
  declineBtn: { padding: '12px', border: 'none', background: 'none', color: '#c9c9d6', cursor: 'pointer', fontSize: 15, fontWeight: 600 },
  acceptBtn:  { height: 52, borderRadius: 26, border: 'none', background: '#fdc149', color: '#1a1a2e', fontWeight: 700, fontSize: 16, cursor: 'pointer' },
};
